import { initializeApp } from 'firebase/app'
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
} from 'firebase/auth'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}
// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app)

// Configure Firebase Auth persistence for new tabs
// browserLocalPersistence ensures authentication state is preserved across browser sessions and tabs
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Firebase Auth persistence set to browserLocalPersistence')
  })
  .catch(error => {
    console.error('Failed to set Firebase Auth persistence:', error)
    // Fallback to session persistence if local persistence fails
    return setPersistence(auth, browserSessionPersistence)
  })

export default app
